import { useTranslation } from 'react-i18next';
import { DialogShellNav } from '@bliks-io/ui';
import type { EditorDepartment } from './editorDepartments';

interface DepartmentRailProps {
  departments: EditorDepartment[];
  selectedId: string | undefined;
  onSelect: (departmentId: string | undefined) => void;
}

export function DepartmentRail({ departments, selectedId, onSelect }: DepartmentRailProps) {
  const { t } = useTranslation();
  const items = [
    {
      id: 'all',
      label: t('entityPicker.common.allFacet'),
      count: departments.reduce((sum, department) => sum + department.processes.length, 0),
      active: selectedId === undefined,
      onSelect: () => onSelect(undefined)
    },
    ...departments.map((department) => ({
      id: department.id,
      label: department.name,
      count: department.processes.length,
      active: department.id === selectedId,
      onSelect: () => onSelect(department.id)
    }))
  ];

  return (
    <div className="-my-1 -ml-1 w-64 shrink-0 scroll-py-1 overflow-y-auto p-1">
      <DialogShellNav
        aria-label={t('organization.departments.title')}
        activeStyle="flat"
        sections={[{ id: 'departments', items }]}
      />
    </div>
  );
}
